module.exports = __webpack_public_path__ + "media/components/Agencies/Reports/Index/caret-down-394b42c83987ccb2f3e27bcbaaea274f.svg";